import { PlannedOccurrence } from '@griply/types';
import { isSameDay } from 'date-fns';

// planning echoes existing pins (same ids) — merging without exclusion duplicates them (1.5 MB task-doc incident)
export const mergePlannedOccurrences = (
  existing: PlannedOccurrence[],
  materialised: PlannedOccurrence[],
): PlannedOccurrence[] => {
  const fresh = materialised.filter(
    (occurrence) =>
      !existing.some(({ id }) => id === occurrence.id) &&
      !existing.some(({ date }) => isSameDay(date, occurrence.date)),
  );
  return [...existing, ...fresh];
};
